// Map tile provider abstraction (spec §7.1/§10 "Map caching", build brief stack
// notes). Everything provider-specific lives in this one function + the matching
// runtime-caching entry in vite.config.ts — swap both together to move to a
// provider whose terms explicitly cover offline caching, or to a self-hosted tile
// service, without touching any screen code.
//
// tile.openstreetmap.org's own usage policy does not permit bulk/indefinite offline
// redistribution of its tiles; the service worker therefore caches tiles with a
// bounded size + a 14-day expiry (see vite.config.ts) rather than caching
// unconditionally "forever". For real multi-user deployment, point TILE_URL_TEMPLATE
// at a compliant provider (e.g. MapTiler, Stadia Maps, Thunderforest) or a
// self-hosted tile server instead.
// `leaflet` is loaded lazily by lib/map.ts (see the comment there) so it stays out
// of the initial bundle; this module only needs leaflet's *types*, which are erased
// at compile time and cost nothing at runtime.
import type * as LeafletNS from 'leaflet';

export const TILE_URL_TEMPLATE = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const TILE_ATTRIBUTION = '&copy; OpenStreetMap contributors';
export const TILE_MAX_ZOOM = 18;

export function addTileLayer(L: typeof LeafletNS, map: LeafletNS.Map): LeafletNS.TileLayer {
  return L.tileLayer(TILE_URL_TEMPLATE, {
    attribution: TILE_ATTRIBUTION,
    maxZoom: TILE_MAX_ZOOM,
  }).addTo(map);
}
